import { useEffect, useState } from "react";

import { AxiosError } from "axios";

import { ErrorMessage } from "../models/ErrorMessage.ts";
import { HandledErrorMessages } from "../utils/Error/HandledErrorMessages.ts";

export const useError = (queryError: Error | null) => {
  const [errorMessage, setErrorMessage] = useState<ErrorMessage>({
    code: 0,
    description: "",
    title: ""
  });
  useEffect(() => {
    if (queryError) {
      const axiosError = queryError as AxiosError;
      const handledError = HandledErrorMessages[axiosError.response?.status || 500];
      setErrorMessage({
        ...handledError,
        description:
          axiosError.response?.data?.toString() ||
          "An unexpected error has occurred. Please try again later."
      });
    }
  }, [queryError]);

  return { errorMessage };
};
